import {
  Badge,
  Center,
  Group,
  Paper,
  RingProgress,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconTrendingDown, IconTrendingUp } from "@tabler/icons-react";

import { scoreColor } from "./utils";

function ScoreHeader({ current, preview, totalOk, total }) {
  const delta = preview - current;
  const deltaColor = delta > 0 ? "green" : delta < 0 ? "orange" : "gray";
  const DeltaIcon =
    delta > 0 ? IconTrendingUp : delta < 0 ? IconTrendingDown : null;

  return (
    <Paper
      withBorder
      radius="md"
      p="md"
      style={{
        background:
          "linear-gradient(135deg, var(--mantine-color-blue-0), var(--mantine-color-cyan-0))",
      }}
    >
      <Group justify="space-between" wrap="nowrap" align="center">
        <Group gap="md" wrap="nowrap" align="center">
          <RingProgress
            size={88}
            thickness={8}
            roundCaps
            sections={[{ value: preview, color: scoreColor(preview) }]}
            label={
              <Center>
                <Stack gap={0} align="center">
                  <Text fw={700} size="lg" lh={1}>
                    {preview}
                  </Text>
                  <Text size="10px" c="dimmed">
                    /100
                  </Text>
                </Stack>
              </Center>
            }
          />
          <Stack gap={2}>
            <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
              App feature usage score (preview)
            </Text>
            <Group gap={6} align="baseline">
              <Text c="dimmed">From {current}</Text>
              <Text c="dimmed">→</Text>
              <Text fw={700} c={scoreColor(preview)}>
                {preview}
              </Text>
              {DeltaIcon && (
                <Badge
                  color={deltaColor}
                  variant="light"
                  leftSection={<DeltaIcon size={12} />}
                  size="sm"
                >
                  {delta > 0 ? "+" : ""}
                  {delta}
                </Badge>
              )}
            </Group>
          </Stack>
        </Group>
        <Stack gap={2} align="end">
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            Total weights
          </Text>
          <Title order={3} c={totalOk ? "green" : "red"}>
            {total.toFixed(1)}% {totalOk ? "✓" : "✗"}
          </Title>
        </Stack>
      </Group>
    </Paper>
  );
}

export default ScoreHeader;
